// extracted by mini-css-extract-plugin
export default {"image":"Stub_image__2dR9Q","text":"Stub_text__+TdwH","phone":"Stub_phone__Kk7co","placeHolderShimmer":"Stub_placeHolderShimmer__1mZQC"};